export {
  deleteEmptyKeys,
  trimString,
  formatUSPhoneNumber,
  fixURL,
  checkIfClient,
  pluralizeNoun,
  getFullEntityName,
  getObjectIf,
} from "./utils";
export { formatNumbers } from "./numbers";
export { safeGetDate } from "./date";
export {
  default as Cookies,
  COOKIE_MESSAGES_KEY,
  USER_BASE_KEY,
  GLENCOCO_COOKIE_TOKEN,
} from "./cookies";

export { type JwtI, parseJwt, getExpirationTime } from "./jwt";

export { getS3AssetPath, getS3AudioPath } from "./s3";

export { getInitialsFromUsername } from "./user";

export { clsxMerge } from "./styles";

export { getEmailsFromString, yupEmailListSchema } from "./email";

export {
  getCanonicalMeetingTime,
  isMeetingUpcoming,
  partitionUpcomingMeetings,
  type WithCanonicalTime,
  type BMCESnapshotLike,
  type PartitionUpcomingResultI,
} from "./canonical-meeting-time";
